import React from 'react'

import { Table } from 'antd'
import { Link } from 'react-router-dom'
import Icon from 'react-fontawesome'

import data from './data'

class Home extends React.Component {
  render() {
    const cols = [
      { title: 'Source Field', dataIndex: 'sourceField', key: 'sourceField' },
      { title: 'Transform', dataIndex: 'transform', key: 'transform' },
      { title: 'Target Field (NIEM)', dataIndex: 'targetField', key: 'targetField' },
      {
        title: '',
        key: 'action',
        render: (text, record) => (
          <Link to={`/transform/${record.key}`}><Icon name="edit" /> Edit</Link>
        ),
      }
    ]
    return (
      <div>
        <h1>Transformation Rules for Exampleville Police Department</h1>
        <Table dataSource={data} columns={cols} />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/Home.js